import React from "react";
import { Link } from "react-router-dom";
import Text from "../atoms/Text";
import Icon from "../atoms/Icon";

const footerLinkStyle = {
  textDecoration: "none",
  cursor: "pointer",
  width: "fit-content",
};

function FooterLink({ to, children, width }) {
  return (
    <Link to={to} style={{ ...footerLinkStyle, width: width || "fit-content" }}>
      <Text
        size="px14"
        weight="w400"
        color="gray4"
        extraStyles={{
          lineHeight: "150%",
          textAlign: "start",
          width: width || "fit-content",
          cursor: "pointer",
        }}
        hoverEffect="true"
        hoverColor="white"
      >
        {children}
      </Text>
    </Link>
  );
}

export default function Footer() {
  return (
    <div
      className="footer"
      style={{
        backgroundColor: "var(--gray9)",
        backgroundImage: `url(${require("../../assets/FooterBackground.png")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "90px",
          padding: "80px 300px 60px",
        }}
      >
        <div
          className="companyInfo"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            alignItems: "start",
            marginRight: '30px'
          }}
        >
          <Icon
            src={require("../../assets/FooterLogo.png")}
            size="width: '183px', height: '38px'"
          />
          <Text
            size="px14"
            weight="w400"
            color="gray4"
            extraStyles={{
              lineHeight: "150%",
              width: "300px",
              textAlign: "start",
            }}
          >
            Morbi cursus porttitor enim lobortis molestie. Duis gravida turpis
            dui, eget bibendum magn.
          </Text>
          <Icon
            src={require("../../assets/Social Medias.png")}
            size="width: '184px', height: '40px'"
          />
        </div>
        <div className='quickLinks' style={{display: 'flex', flexDirection:'column', gap: '12px', width: '107px'}}>
            <Text size='px18' weight='w500' color='white' extraStyles={{lineHeight: '150%', textAlign: 'start', width: '107px'}}>My Account</Text>
            <span style={{width: '24px', height: '2px', borderRadius: '2px', backgroundColor: 'var(--primary)', display: 'block', marginBottom: '8px'}}></span>
            <FooterLink to='/profile' width='107px'>My Account</FooterLink>
            <FooterLink to='/profile' width='107px'>Order History</FooterLink>
            <FooterLink to='/cart' width='107px'>Shopping Cart</FooterLink>
            <FooterLink to='/wishlist' width='107px'>Wishlist</FooterLink>
        </div>
        <div className='quickLinks' style={{display: 'flex', flexDirection:'column', gap: '12px', width: '130px'}}>
            <Text size='px18' weight='w500' color='white' extraStyles={{lineHeight: '150%', textAlign: 'start', width: '130px'}}>Helps</Text>
            <span style={{width: '24px', height: '2px', borderRadius: '2px', backgroundColor: 'var(--primary)', display: 'block', marginBottom: '8px'}}></span>
            <FooterLink to='/contact' width='130px'>Contact</FooterLink>
            <FooterLink to='/' width='130px'>FAQs</FooterLink>
            <FooterLink to='/' width='130px'>Terms & Conditions</FooterLink>
            <FooterLink to='/' width='130px'>Privacy Policy</FooterLink>
        </div>
        <div className='quickLinks' style={{display: 'flex', flexDirection:'column', gap: '12px', width: '82px'}}>
            <Text size='px18' weight='w500' color='white' extraStyles={{lineHeight: '150%', textAlign: 'start', width: '82px'}}>Proxy</Text>
            <span style={{width: '24px', height: '2px', borderRadius: '2px', backgroundColor: 'var(--primary)', display: 'block', marginBottom: '8px'}}></span>
            <FooterLink to='/' width='82px'>About</FooterLink>
            <FooterLink to='/shop' width='82px'>Shop</FooterLink>
            <FooterLink to='/' width='82px'>Blogs</FooterLink>
            <FooterLink to='/profile' width='82px'>Track Order</FooterLink>
        </div>
        <div className='quickLinks' style={{display: 'flex', flexDirection:'column', gap: '12px'}}>
            <Text size='px18' weight='w500' color='white' extraStyles={{lineHeight: '150%', textAlign: 'start'}}>Download Mobile App</Text>
            <span style={{width: '24px', height: '2px', borderRadius: '2px', backgroundColor: 'var(--primary)', display: 'block', marginBottom: '8px'}}></span>
            <div style={{display: 'flex', flexDirection:'row', gap:'8px'}}>
                <Icon src={require('../../assets/AppStore.png')} size="width: '154px', height: '58.5px'"/>
                <Icon src={require('../../assets/GooglePlay.png')} size="width: '154px', height: '58.5px'"/>
            </div>
        </div>
      </div>
      <div className="copyRight" style={{padding: '30px 300px', borderTop: '1px solid var(--gray7)', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
        <Text size='px14' weight='400' color='gray5' extraStyles={{lineHeight: '150%'}}>Agon Mustafa © 2026. All Rights Reserved</Text>
        <Icon src={require('../../assets/paymentMethodsBlack.png')} size="width: '277px', height: '32px'"/>
      </div>
    </div>
  );
}
